"use client";

import type { PitchMiddleware } from "@/app/(application)/(normal)/create/components/input/types";
import { getSegmentationPoints2 } from "@/components/pitchCorrection/PitchCorrection";
import { pitchDiffsFromSemitoneData } from "@/components/pitchCorrection/vibratoKnob/pitchDiffsFromSemitoneData";

export const applyPitchMiddleware =
  (...middleware: PitchMiddleware[]) =>
  (pitches: number[]) => {
    const circles = getSegmentationPoints2(pitches);
    // A pitchless clip (silence) segments into no markers; every middleware indexes circles[0], so there is nothing to shift and the pitches pass through unchanged — the editor then reports "no pitch found" instead of the getter rejecting.
    if (circles.length === 0) {
      return pitches;
    }
    const pitchDiffs = pitchDiffsFromSemitoneData(pitches, circles);
    return middleware.reduce(
      (incomingPitches, m) => m({ circles, pitchDiffs })(incomingPitches),
      pitches
    );
  };
